// <head> metadata for DailyDbosActionsCountPage (https://www.dbos.dev/daily-dbos-actions-count).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'How to report your daily DBOS actions count',
    },
    {
      name: 'description',
      content: 'SQL statement will report your daily number of DBOS actions to help you monitor costs.',
    },
    {
      property: 'og:title',
      content: 'How to report your daily DBOS actions count',
    },
    {
      property: 'og:description',
      content: 'SQL statement will report your daily number of DBOS actions to help you monitor costs.',
    },
    {
      name: 'twitter:title',
      content: 'How to report your daily DBOS actions count',
    },
    {
      name: 'twitter:description',
      content: 'SQL statement will report your daily number of DBOS actions to help you monitor costs.',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/daily-dbos-actions-count',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
